import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import styles from './Spinner.module.scss.js';

var Spinner = function (props) { return (jsxs("div", { className: classNames(styles.container, props.className), children: [jsx("div", { className: styles.spinner }), props.label && jsx("div", { className: styles.label, children: props.label })] })); };

export { Spinner as default };
//# sourceMappingURL=Spinner.js.map
